import React from "react";

const getTipsOverdue = ({ interval }) => {
  return (
    <span>
      基本信息
      {interval / 1440 < -10 ? (
        <span style={{ color: "red", paddingLeft: "10px" }}>
          异常终止(逾期{Math.ceil(Math.abs(interval / 1440))}天)
        </span>
      ) : null}
    </span>
  );
};
export default getTipsOverdue;



// WEBPACK FOOTER //
// ./src/components/incubator/comm/TipsOverdue.js